export default __webpack_public_path__ + "static/media/callable-final-design-04.6c1c68b3.png";